import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import SentSmsFull from '@/data/models/domain/SentSmsFull'

@OrmModel(modelNames.BULK_SENT_SMS)
export default class BulkSentSms extends SentSmsFull {}
